import { showWarningToast } from '../../constToast/constToast'

// type == 0 -> yeni əlavə olunan attachment, type == 2 -> silinmiş
// fileLink boşdursa upload tamamlanmayıb, belə attachment save-ə getməməlidir.
export const isPendingAttachment = (attachment) =>
  attachment?.type == 0 && !attachment?.fileLink

export const getPendingAttachments = (attachments = []) =>
  (attachments || []).filter(isPendingAttachment)

export const hasPendingAttachments = (attachments = []) =>
  getPendingAttachments(attachments).length > 0

// true qaytarır -> attachment-lər save üçün hazırdır
export const validateAttachments = (attachments = [], { silent = false } = {}) => {
  const pending = getPendingAttachments(attachments)
  if (pending.length === 0) return true

  if (!silent) {
    const names = pending.map((item) => item?.name).filter(Boolean).join(', ')
    showWarningToast(
      names
        ? `Upload is not completed for: ${names}. Please re-upload or remove the file.`
        : 'FileLink is required and cannot be null or empty.'
    )
  }
  return false
}

// İç-içə obyektlərdə (payload) attachment massivlərini tapıb yığır.
export const collectAttachments = (source) => {
  const found = []
  const seen = new Set()

  const walk = (node) => {
    if (!node || typeof node !== 'object') return
    if (seen.has(node)) return
    seen.add(node)

    if (Array.isArray(node)) {
      node.forEach(walk)
      return
    }

    if ('attachmentId' in node && 'type' in node) {
      found.push(node)
      return
    }

    Object.values(node).forEach(walk)
  }

  walk(source)
  return found
}

// Bütün payload boyunca fileLink-i olmayan attachment axtarır
export const validateAttachmentsDeep = (payload, options) =>
  validateAttachments(collectAttachments(payload), options)

// Valideyn komponent çox vaxt `initialData={attachments || []}` kimi hər render-də
// yeni massiv yaradır. Məzmun eynidirsə state-i yeniləmək olmaz, əks halda
// setFiles -> setValue -> valideyn state -> yeni initialData -> setFiles ... sonsuz dövrə yaranır.
export const isSameAttachmentList = (a, b) => {
  const listA = a || []
  const listB = b || []
  return listA.length === listB.length && listA.every((item, index) => item === listB[index])
}
